/* VivaLaCozy — premium layer: gentle scroll reveal. Visual only. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var root = document.documentElement;
  var selectors = [
    '.shopify-section--collection-list .thumbnail',
    '.shopify-section--featured-collection .thumbnail',
    '.shopify-section--product-recommendations .thumbnail',
    '.collection-matrix .thumbnail',
    '.product-list .thumbnail',
    '.image-with-text-container',
    '.rich-text__content',
    '.newsletter_section .section_form',
    '.shopify-section h2.title'
  ];

  function init() {
    var nodes = document.querySelectorAll(selectors.join(','));
    if (!nodes.length) return;
    root.classList.add('vlc-js');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    var groupIndex = new WeakMap();
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.closest('header, .header, footer, .quick-shop, .fancybox-container')) return;
      var parent = el.parentElement;
      var i = groupIndex.get(parent) || 0;
      groupIndex.set(parent, i + 1);
      el.style.setProperty('--vlc-delay', Math.min(i, 6) * 70 + 'ms');
      el.classList.add('vlc-reveal');
      io.observe(el);
    });

    // safety net: never leave content hidden
    setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('.vlc-reveal:not(.is-in)'), function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-in');
      });
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
